/**
 * Слайды главной страницы.
 * Изображения: WebP в public/slider/ (и public/slider/mobile/).
 *
 * Десктоп: 1280×400, контейнер 16:5.
 * Мобильные: 750×422 (16:9), крупный текст под узкий экран.
 * imageMobile — необязательно; без него на телефоне показывается десктопная версия.
 * href — необязательная ссылка при клике на слайд.
 */
export const SLIDES = [
  {
    id: 1,
    image: '/slider/wb.webp',
    imageMobile: '/slider/mobile/wb.webp',
    alt: 'Мы на wildberries!',
    href: 'https://www.wildberries.ru/brands/311261805-nextcake',
  },
  {
    id: 2,
    image: '/slider/delivery.webp',
    imageMobile: '/slider/mobile/delivery.webp',
    alt: 'Доставка по Волгограду',
    href: '/delivery',
  },
  {
    id: 3,
    image: '/slider/studio.webp',
    imageMobile: '/slider/mobile/studio.webp',
    alt: 'Студия nextcake',
    href: '/studio',
  },
  {
    id: 4,
    image: '/slider/nextcake.webp',
    imageMobile: '/slider/mobile/nextcake.webp',
    alt: 'Акция',
  },
];
